namespace GeniuzPOS.ReportMasterData {
    export class Report_1504_NColumns {
        static columnsKey = 'ReportMasterData.Report_1504_N';
    }
}
